module.exports = __webpack_public_path__ + "75359ec1c99b3e954de3f014ac5eb994.svg";